import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-b from-[#0F172A] to-[#1B5E20] text-white overflow-hidden" data-id="element-61">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-62"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-64">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-65">
            <span className="inline-block py-1 px-3 rounded-full bg-[#F59E0B] text-[#0F172A] font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-66">
              📘 MegaPack Educación Física LISTA™
            </span>

            <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight" data-id="element-67">
              Planificá menos. <br data-id="element-68" />
              <span className="text-[#F59E0B]" data-id="element-69">Enseñá mejor.</span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-200 mb-8 font-medium" data-id="element-70">
              Todo tu año de Educación Física resuelto en un solo lugar.
            </p>

            <div className="space-y-4 mb-10 max-w-lg mx-auto lg:mx-0" data-id="element-71">
              {['👉 Acceso inmediato – Descarga digital', '👉 Material listo para usar, imprimir o editar', '👉 Ideal para docentes de Educación Física'].map((item, index) => <div key={index} className="flex items-center gap-3 text-lg" data-id="element-72">
                  <Check className="w-6 h-6 text-[#F59E0B] flex-shrink-0" data-id="element-73" />
                  <span data-id="element-74">{item.replace('👉 ', '')}</span>
                </div>)}
            </div>

            <button onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-red-700 text-white font-black text-xl py-4 px-8 rounded-full shadow-[0_0_20px_rgba(220,38,38,0.5)] transform hover:scale-105 transition-all duration-300 animate-pulse w-full md:w-auto cursor-pointer" data-id="element-75">
              🎯 ¡SÍ, QUIERO RESOLVER MI AÑO AHORA!
              <ArrowRight className="w-6 h-6" data-id="element-76" />
            </button>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative group cursor-pointer" data-id="element-77">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#F59E0B] to-[#DC2626] rounded-xl blur-lg opacity-30 group-hover:opacity-50 transition duration-500" data-id="element-78"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1YUtJDJVs1ZKhrEJoXRy3i/1_COVER.png" alt="MegaPack Educación Física LISTA Cover" className="relative rounded-xl shadow-2xl transform group-hover:scale-[1.02] transition duration-500 w-full max-w-lg mx-auto" data-id="element-79" />
          </motion.div>
        </div>
      </div>

      {/* Wave Separator */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]" data-id="element-80">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-[calc(100%+1.3px)] h-[60px]" data-id="element-81">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-82"></path>
        </svg>
      </div>
    </section>;
}